const BreadcrumbManager = {
  storageKey: 'breadcrumb_history_v4',
  
  init() {
    this.trackHistory();
    this.renderCrumbs();
    this.bindMegaMenu();
  },

  normalizeUrl(url) {
    if (!url) return '';
    try {
      // Remove query params and trailing slash
      return url.split('?')[0].replace(/\/$/, '') || '/';
    } catch (e) {
      return url;
    }
  },

  trackHistory() {
    let history = [];
    try {
      history = JSON.parse(sessionStorage.getItem(this.storageKey)) || [{t: 'Home', u: '/', type: 'home'}];
    } catch (e) {
      history = [{t: 'Home', u: '/', type: 'home'}];
    }

    const currentPage = {
      t: this.getCurrentTitle(),
      u: window.location.pathname,
      type: this.getPageType()
    };

    const normalizedCurrentUrl = this.normalizeUrl(currentPage.u);

    // Reset history for Home or Search
    if (normalizedCurrentUrl === '/' || currentPage.type === 'search') {
      history = [{t: 'Home', u: '/', type: 'home'}];
    } 
    else if (currentPage.type === 'collection') {
      // Remove previous product if any
      history = history.filter(item => item.type !== 'product');

      // Maintain collection history
      const index = history.findIndex(item => this.normalizeUrl(item.u) === normalizedCurrentUrl);
      if (index !== -1) {
        history = history.slice(0, index + 1);
      } else {
        history.push(currentPage);
      }
    }
    else if (currentPage.type === 'product') {
      const productInfo = document.querySelector('product-info[data-main-product]');
      if (productInfo) {
        const productCollectionsAttr = productInfo.getAttribute('data-product-collections');
        const primaryCollectionAttr = productInfo.getAttribute('data-primary-collection');
        
        // Remove previous product if any
        history = history.filter(item => item.type !== 'product');
        
        let validCollectionFound = false;

        // Check history for last valid collection
        if (productCollectionsAttr) {
          try {
            const productCollections = JSON.parse(productCollectionsAttr);
            for (let i = history.length - 1; i >= 0; i--) {
              const histItem = history[i];
              const normalizedHistUrl = this.normalizeUrl(histItem.u);
              
              if (
                productCollections.some(c => {
                  const normalizedCollUrl = this.normalizeUrl(c.url);
                  return normalizedHistUrl === normalizedCollUrl || normalizedHistUrl.startsWith(normalizedCollUrl + '/');
                })
              ) {
                history = history.slice(0, i + 1);
                validCollectionFound = true;
                break;
              }
            }
          } catch (e) {
            console.error("Error parsing product collections", e);
          }
        }

        // If no valid collection found in history, fallback to primary collection
        if (!validCollectionFound && primaryCollectionAttr) {
          try {
            const primaryCollection = JSON.parse(primaryCollectionAttr);
            if (primaryCollection && primaryCollection.url && !this.isExcludedCollection(primaryCollection.url)) {
              history = [
                {t: 'Home', u: '/', type: 'home'},
                {t: primaryCollection.title, u: primaryCollection.url, type: 'collection'}
              ];
            } else {
              history = [{t: 'Home', u: '/', type: 'home'}];
            }
          } catch (e) {
            console.error("Error parsing primary collection", e);
            history = [{t: 'Home', u: '/', type: 'home'}];
          }
        } else if (!validCollectionFound) {
          history = [{t: 'Home', u: '/', type: 'home'}];
        }

        history.push(currentPage);
      } else {
        history = history.filter(item => item.type !== 'product');
        history.push(currentPage);
      }
    } else {
      // Pages and others
      history = history.filter(item => item.type !== 'page' && item.type !== 'other' && item.type !== 'product');
      history.push(currentPage);
    }

    sessionStorage.setItem(this.storageKey, JSON.stringify(history));
  },

  getPageType() {
    const path = window.location.pathname;
    if (path === '/') return 'home';
    if (path.startsWith('/search')) return 'search';
    if (path.includes('/collections/') && !path.includes('/products/')) return 'collection';
    if (path.includes('/products/')) return 'product';
    if (path.includes('/pages/')) return 'page';
    return 'other';
  },

  isExcludedCollection(url) {
    const exclusionList = ['all', 'frontpage', 'new-arrivals', 'bestsellers', 'trending', 'featured'];
    const handle = url.split('/').filter(Boolean).pop();
    if (!handle) return false;
    if (handle.includes('shop-all')) return true;
    return exclusionList.includes(handle);
  },

  getCurrentTitle() {
    const activeLink = document.querySelector(
      '.breadcrumb__list .breadcrumb__item a[aria-current="page"]'
    );
    if (activeLink && activeLink.textContent) {
      return activeLink.textContent.trim();
    }
    return document.title.split('–')[0].split('-')[0].trim();
  },

  bindMegaMenu() {
    document.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', () => {
        const href = link.getAttribute('href');
        if (!href || href.startsWith('#')) return;

        const isExternal = link.hostname !== window.location.hostname;
        const isHome = href === '/' || href === window.location.origin + '/';

        if (isExternal || isHome) {
          sessionStorage.removeItem(this.storageKey);
        }
      });
    });
  },

  renderCrumbs() {
    let history = [];
    try {
      history = JSON.parse(sessionStorage.getItem(this.storageKey));
    } catch (e) {
      return;
    }
    
    if (!history || history.length <= 1) return; 

    const containers = document.querySelectorAll('.breadcrumb__list');
    if (containers.length === 0) return;
    
    let displayHistory = [];
    if (history.length > 3) {
      displayHistory = [history[0], history[history.length - 2], history[history.length - 1]];
    } else {
      displayHistory = history;
    }

    const dividerHtml = `<span class="breadcrumb__divider" aria-hidden="true"><svg width="8" height="16" viewBox="0 0 8 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.77162 8.47377L3.00028 12.2451L2.05762 11.3024L5.35762 8.00243L2.05762 4.70243L3.00028 3.75977L6.77162 7.5311C6.8966 7.65612 6.96681 7.82566 6.96681 8.00243C6.96681 8.17921 6.8966 8.34875 6.77162 8.47377Z" fill="#070707" fill-opacity="0.6"/></svg></span>`;

    let newHtml = '';
    displayHistory.forEach((item, index) => {
      const isLast = index === displayHistory.length - 1;
      newHtml += `
        <li class="breadcrumb__item">
          <a href="${item.u}" ${isLast ? 'aria-current="page"' : ''} title="${item.t.replace(/"/g, '&quot;')}">${item.t}</a>
        </li>
      `;
      if (!isLast) {
        newHtml += dividerHtml;
      }
    });

    containers.forEach(container => {
      container.innerHTML = newHtml;
    });

    document.querySelectorAll('.custom-breadcrumb').forEach(breadcrumb => {
      breadcrumb.style.opacity = '1';
    });
  }
};

document.addEventListener('DOMContentLoaded', () => BreadcrumbManager.init());